import { Vehicle } from '@agilox/common';

const SECONDS_TO_MILLISECONDS = 1000;

export function getEarliestSubscriptionEnd(vehicles: Vehicle[]): number | undefined {
	if (!vehicles || vehicles.length === 0) {
		return undefined;
	}

	const subscriptionEnds = vehicles.map((vehicle: Vehicle) => vehicle.subscription_end);
	return Math.min(...subscriptionEnds) * SECONDS_TO_MILLISECONDS;
}
